module.exports = "pegasus/assets/theme4/twitter.png";